import { useCallback, useId } from "react";

const ToggleSwitch = ({
  onChange,
  checked,
  // disabled,
}: {
  onChange: (checked: boolean) => void;
  checked: boolean;
  // disabled: boolean;
}) => {
  const id = useId();

  const handleChange = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        className="hidden"
        // disabled={disabled}
      />
      <label
        htmlFor={id}
        className={`
          cursor-pointer relative flex items-center
          min-w-[40px] h-3 px-4 rounded-full transition-colors
          ${checked ? "bg-orange-400" : "bg-[#CCCCCC]"}
          border border-gray-300 text-center
        `}
        style={{ minWidth: 50, height: 24 }}
      >
        <span
          className={`
            absolute top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-white shadow transition-all duration-200
            ${checked ? "right-2" : "left-2"}
          `}
          style={{
            left: checked ? "auto" : 2,
            right: checked ? 2 : "auto",
          }}
        />
      </label>
    </div>
  );
};

export default ToggleSwitch;
